import { HTTP } from '../core/http/http-token';
import Routing from '../core/router/router';
import b64toBlob from 'b64-to-blob';

export default {
  methods: {
    uploadThumbnail(blob, params) {
      const url = Routing.generate('api_post_lives_thumb');
      if (params) {
        this.appendProgressCircle(params);
      }
      const config = {
        header: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: progressEvent => {
          if (params) {
            const percentCompleted = Math.round(
              (params.current / params.total) * 100 +
                (progressEvent.loaded * 100) / progressEvent.total / params.total,
            );
            this.updateProgressCircle(params, percentCompleted);
            if (params.current === params.total && percentCompleted === 100) {
              this.removeProgressCircle(params);
            }
          }
        },
      };
      let formData = new FormData();

      formData.append('empApiFileForm[thumb]', blob);
      if (params && params.type) {
        formData.append('type', params.type);
      }

      return new Promise((resolve, reject) => {
        HTTP(window.ApiToken)
          .post(url, formData, config)
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    async processFile(file) {
      const fileReader = new FileReader();
      let base64;
      return await new Promise((resolve, reject) => {
        fileReader.onload = fileLoadedEvent => {
          base64 = fileLoadedEvent.target.result;
          file.dataURL = base64;

          const contentType = file.type;
          const b64Data = file.dataURL;
          const replaceString = 'data:' + contentType + ';base64,';

          resolve(b64toBlob(b64Data.replace(replaceString, ''), contentType));
        };
        fileReader.readAsDataURL(file);
      });
    },
    appendProgressCircle(params) {
      const progressEl = document.querySelector(`#${params.id} .dz-upload-progress-wrapper`);
      if (progressEl) {
        return;
      }
      const progressValue = 0;
      const progressCirlcleEl = document.createElement('div');
      progressCirlcleEl.className = 'dz-upload-progress-wrapper';
      progressCirlcleEl.innerHTML = `<div class="c100 blue p${progressValue}">
                              <span>${progressValue}%</span>
                              <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                              </div>
                            </div>`;
      document.getElementById(params.id).appendChild(progressCirlcleEl);
    },
    updateProgressCircle(params, progressValue) {
      const progressEl = document.querySelector(`#${params.id} .dz-upload-progress-wrapper`);
      progressEl.classList.add('visible');
      const circleEl = progressEl.querySelector('.c100');
      circleEl.className = `c100 blue p${progressValue}`;
      circleEl.querySelector('span').innerHTML = `${progressValue}%`;
    },
    removeProgressCircle(params) {
      const wrapperEl = document.getElementById(params.id);
      const progressEl = document.querySelector(`#${params.id} .dz-upload-progress-wrapper`);
      progressEl.classList.remove('visible');
      setTimeout(() => {
        wrapperEl.removeChild(progressEl);
      }, 500);
    },
    downloadURI(uri, name) {
      let urlLink = document.createElement('a');
      urlLink.download = name;
      urlLink.href = uri;
      document.body.appendChild(urlLink);
      urlLink.click();
      document.body.removeChild(urlLink);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/UploadMixin.js